import { render, staticRenderFns } from "./move_item_mrn_grv.vue?vue&type=template&id=50794be3&scoped=true"
import script from "./move_item_mrn_grv.vue?vue&type=script&lang=js"
export * from "./move_item_mrn_grv.vue?vue&type=script&lang=js"
import style0 from "./move_item_mrn_grv.vue?vue&type=style&index=0&id=50794be3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50794be3",
  null
  
)

export default component.exports